import { Component } from "@angular/core";

@Component({
    selector: 'home',
    templateUrl: './home.component.html',
    styleUrls: ['../sass/flayout.scss', '../sass/grid-layout.scss','../sass/ie_grid_fix.scss']
})
export class HomeComponent {
}